import { WorkCardData } from 'shared/interfaces';

export const FETCH_WORK_CARDS = 'FETCH_WORK_CARDS';
export const FETCH_WORK_CARDS_SUCCESS = 'FETCH_ASSIGNMENT_SUMMARY_SUCCESS';
export const FETCH_WORK_CARDS_ERROR = 'FETCH_ASSIGNMENT_SUMMARY_ERROR';
export const SET_ACTIVE_CARD = 'SET_ACTIVE_CARD';

export interface WorkCardState {
  loading: boolean;
  activeCard: string;
  data: WorkCardData[];
}

interface FetchWorkCards {
  type: typeof FETCH_WORK_CARDS;
}

interface FetchWorkCardsSuccess {
  type: typeof FETCH_WORK_CARDS_SUCCESS;
  data: WorkCardData[];
}

interface FetchWorkCardsError {
  type: typeof FETCH_WORK_CARDS_ERROR;
}

interface SetActiveCard {
  type: typeof SET_ACTIVE_CARD;
  cardId: string;
}

export type WorkCardsActionTypes =
  | FetchWorkCards
  | FetchWorkCardsSuccess
  | FetchWorkCardsError
  | SetActiveCard;
